export const ModalFooter = (props) =>
  <footer class='control-modal-footer'>
    {props.children}
  </footer>
